import { useQuery } from '@tanstack/react-query';
import { fetchScopedDealers } from '../services/security-groups';
import type { SecurityDealerListResponse } from '../types/security-admin.types';

export function useScopedDealersQuery(ownerDealerId: string | undefined, search: string) {
  const trimmed = search.trim();
  const effectiveSearch = trimmed.length >= 2 ? trimmed : undefined;

  return useQuery<SecurityDealerListResponse>({
    queryKey: ['security-admin', 'scoped-dealers', ownerDealerId, effectiveSearch ?? ''],
    queryFn: () => {
      if (!ownerDealerId) throw new Error('ownerDealerId is required');
      return fetchScopedDealers(ownerDealerId, { search: effectiveSearch, per_page: 200 });
    },
    enabled: Boolean(ownerDealerId),
    staleTime: 2 * 60 * 1000,
    placeholderData: (prev) => prev,
  });
}
